/* eslint-disable */
export default {
  title: 'ボイスメッセージで返信',
  customMessage: 'カスタムメッセージ',
  customMessagePlaceholder: 'カスタムメッセージを入力',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
